import { render } from "./steps.md?vue&type=template&id=706a55ca"
import script from "./steps.md?vue&type=script&lang=js"
export * from "./steps.md?vue&type=script&lang=js"
script.render = render

export default script